<script setup>
import { Link } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Icons/Logo'
import ButtonSetSNS from '@/Shared/ButtonSet/ButtonSetSNS'
import FooterLi from './FooterLi'
import Footerinfo from './_footer.json'
const naviJson = Footerinfo
</script>

<template>
  <div class="footer relative z-[25] py-[50px] p-[30px] sm:px-[50px] sm:py-[60px] md:px-[25px] lg:px-[40px] bg-black xl:bg-[#fafafa] text-white xl:text-black overflow-x-hidden">
    <Link href="/" class="center-container mb-[40px]">
      <Logo class="w-full h-auto max-w-[350px] xl:hidden" type="white1" />
      <Logo class="w-full h-auto max-w-[350px] hidden xl:block" type="green1" />
    </Link>
    <ul class="mx-auto max-w-[700px] md:max-w-[1000px] sm:flex sm:justify-center sm:flex-wrap sm:mb-[20px]">
      <li v-for="(category, index) in naviJson" :key="index" class="pb-[30px] sm:px-[25px] md:px-[15px] lg:px-[20px] xl:px-[15px] 2xl:px-[25px] sm:w-1/3 md:w-1/5">
        <h4 class="text-[14px] font-bold pt-[30px] mb-[12px] border-t-white border-t border-dotted sm:border-t-0 sm:border-b sm:border-dotted sm:pb-[15px] sm:border-b-white xl:border-b-black">{{ category.name }}</h4>
        <ul>
          <FooterLi v-for="item in category.info" :key="item.name" :name="item.name" :url="item.url" :type="item.type" :target="item.target" />
        </ul>
      </li>
    </ul>
    <ButtonSetSNS class="mb-[30px] sm:scale-[1.05] md:scale-[1.1]" />
    <div class="flex items-center justify-center flex-col font-rift font-bold text-[12px] tracking-[0.08em]">
      <!-- <Logo class="w-[65px] h-auto mb-[10px]" type="white2" /> -->
      © 2025 A&amp;F Corporation
    </div>
  </div>
</template>
